import React, { useEffect } from 'react';
import PdfViewer from './PdfViewer';
import MediaPlayer from './shaka/MediaPlayer';
import WindowsARIPlayer from './WindowsARIPlayer';
import AndroidARIPlayer from './AndoidARIPlayer';

interface MediaPlayerHandlerProps {
    type: string;
    resId: string;
    bookId?: string | undefined;
    completeUrl: string;
    source?: string;
}

const MediaPlayerHandler: React.FC<MediaPlayerHandlerProps> = ({
    type,
    resId,
    completeUrl,
    bookId,
    source,
}) => {
    switch (type) {
        case 'pdf':
            return <PdfViewer src={completeUrl} source={source} />;
        case 'video':
        case 'audio':
            return (
                <MediaPlayer
                    src={completeUrl}
                    type={type as 'audio' | 'video'}
                    source={source}
                />
            );
        case 'IR':
        case 'articulate':
            return (
                <div className="w-full h-full overflow-scroll bg-white">
                    <iframe
                        className="h-full w-full shadow-2xl overflow-scroll"
                        src={encodeURI(completeUrl)}
                        // sandbox="allow-same-origin allow-scripts"
                        style={{
                            borderRadius: '8px',
                            width: '100%',
                        }}
                    />
                </div>
            );
        case 'buildr':
            return (
                <div className="w-full h-full overflow-scroll bg-white">
                    <iframe
                        className="h-full w-full shadow-2xl overflow-scroll"
                        src={encodeURI(completeUrl)}
                        // sandbox="allow-same-origin allow-scripts"
                        style={{
                            borderRadius: '8px',
                            width: '100%',
                        }}
                        allowFullScreen
                        allow="fullscreen; clipboard-read; clipboard-write; microphone;"
                    />
                </div>
            );
        case 'ARI':
            if (bookId && completeUrl.indexOf('/windows/') > -1) {
                return (
                    <WindowsARIPlayer
                        completeUrl={completeUrl}
                        bookId={bookId}
                        resId={resId}
                    />
                );
            // } else if (bookId && completeUrl.indexOf('/android/') > -1) {
            //     return (
            //         <AndroidARIPlayer
            //             completeUrl={completeUrl}
            //             bookId={bookId}
            //             resId={resId}
            //         />
            //     );
            } else {
                return (
                    <iframe
                        className="h-full w-full shadow-2xl"
                        src={completeUrl}
                        title="Res Iframe"
                        sandbox="allow-same-origin allow-scripts"
                        style={{ borderRadius: '8px' }}
                    />
                );
            }
        default:
            return (
                <div className="flex items-center justify-center text-3xl h-full w-full">
                    Unsupported Media Type
                </div>
            );
    }
};

export default MediaPlayerHandler;
